import axios from "axios";
import { _Base } from "../_Base";
import { endpoints } from "../endpoints";

export type AutomationClientActionsType =
  | "SET_ONLINE"
  | "SET_OFFLINE"
  | "LOCAL_MODE"
  | "ORCHESTRATION_MODE"
  | "FORCE_UPDATE"
  | "PREVENT_UPDATE"
  | "STANDARD_UPDATE";

export type AutomationServerActionsType =
  | "force"
  | "stop"
  | "resume"
  | "local"
  | "orchestration"
  | "maintenance"
  | "restore-maintenance";

const automationActionsMap: Record<
  AutomationClientActionsType,
  AutomationServerActionsType
> = {
  SET_ONLINE: "restore-maintenance",
  SET_OFFLINE: "maintenance",
  LOCAL_MODE: "local",
  FORCE_UPDATE: "force",
  ORCHESTRATION_MODE: "orchestration",
  PREVENT_UPDATE: "stop",
  STANDARD_UPDATE: "resume",
};

export class Automation extends _Base {
  endPointRoot = process.env.REACT_APP_ROOT_T_REST;

  jsessionid: String;
  constructor(_jsessionid) {
    super();
    this.jsessionid = _jsessionid;
  }

  async getAuthenticated() {
    const url = /*this.endPointRoot +*/ endpoints.automation.login;
    try {
      return await axios.post(
        url,
        {
          token: this.jsessionid,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        },
      );
    } catch (error) {
      console.error("Error during authentication:", error);
      throw error;
    }
  }

  async getSummary() {
    const url = /*this.endPointRoot +*/ endpoints.automation.summary;
    try {
      return this.prepareGet(url, null);
    } catch (error) {
      console.error("Error during fetching summary:", error);
      throw error;
    }
  }

  async getSummaryMaster() {
    const url = /*this.endPointRoot +*/ endpoints.automation.summaryMaster;
    try {
      return this.prepareGet(url, null);
    } catch (error) {
      console.error("Error during fetching master summary:", error);
      throw error;
    }
  }

  async getLogMAster() {
    const url = /*this.endPointRoot +*/ endpoints.automation.logMaster;
    try {
      return this.prepareGet(url, null);
    } catch (error) {
      console.error("Error during fetching master log:", error);
      throw error;
    }
  }

  async triggerActions(target: string, action: AutomationClientActionsType) {
    console.log(`target: ${target}, action: ${automationActionsMap[action]}`);
    const url = /*this.endPointRoot +*/ endpoints.automation.statusComand;
    try {
      const response = await this.prepareGet(url, {
        target,
        command: automationActionsMap[action],
      });
      return response;
    } catch (error) {}
  }
}
